import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconDomainTWTS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 2C4.22386 2 4 2.22386 4 2.5L4 12.2929L2.85355 11.1464C2.65829 10.9512 2.34171 10.9512 2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536L4.14645 13.8536C4.34171 14.0488 4.65829 14.0488 4.85355 13.8536L6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464C6.65829 10.9512 6.34171 10.9512 6.14645 11.1464L5 12.2929L5 2.5C5 2.22386 4.77614 2 4.5 2Z"
        fill="#97B2C4"
      />
      <path
        d="M13.8301 4.29522V5.54262H9V4.29522H13.8301ZM10.4078 2L11.8398 2L11.8398 11.131C11.8398 11.5468 11.8985 11.8586 12.0158 12.0665C12.1371 12.2703 12.2909 12.4075 12.4769 12.4782C12.6671 12.5447 12.8673 12.578 13.0777 12.578C13.2354 12.578 13.3649 12.5696 13.466 12.553C13.5672 12.5322 13.6481 12.5156 13.7087 12.5031L14 13.8254C13.9029 13.8628 13.7674 13.9002 13.5934 13.9376C13.4195 13.9792 13.199 14 12.932 14C12.5275 14 12.1311 13.9106 11.7427 13.7318C11.3584 13.553 11.0388 13.2807 10.784 12.9148C10.5332 12.5489 10.4078 12.0873 10.4078 11.5301L10.4078 2Z"
        fill="#97B2C4"
      />
    </svg>
  )
}

export const IconDomainTWT = createIcon({
  l: IconDomainTWTS,
  m: IconDomainTWTS,
  s: IconDomainTWTS,
  xs: IconDomainTWTS,
  name: 'IconDomainTWT',
})
